// extracted by mini-css-extract-plugin
export default {"dnc_results":"do-not-contact--dnc_results"};